import React from 'react'

import { ReactComponent as Compactor } from 'assets/inventory/container-type/Compactor.svg'
import { ReactComponent as FrontLoad } from 'assets/inventory/container-type/FrontLoad.svg'
import { ReactComponent as HandwashingStation } from 'assets/inventory/container-type/HandwashingStation.svg'
import { ReactComponent as OpenTopBox } from 'assets/inventory/container-type/OpenTopBox.svg'
import { ReactComponent as PortableToilet } from 'assets/inventory/container-type/PortableToilet.svg'
import { ReactComponent as RearLoad } from 'assets/inventory/container-type/RearLoad.svg'
import { ReactComponent as RestroomTrailer } from 'assets/inventory/container-type/RestroomTrailer.svg'
import { ReactComponent as Toter } from 'assets/inventory/container-type/Toter.svg'
import ContainerColor from 'components/inventory/containers/common/ContainerColor'
import T from 'T'
import { get } from 'utils/lodash'

import RenderGetActionsDataCell from './RenderGetActionsDataCell'

export const TYPES = {
  COMPACTOR: 'Compactor',
  FRONT_LOAD: 'Front Load',
  HANDWASHING_STATION: 'Handwashing Station',
  OPEN_TOP_BOX: 'Open Top Box',
  PORTABLE_TOILET: 'Portable Toilet',
  REAR_LOAD: 'Rear Load',
  RESTROOM_TRAILER: 'Restroom Trailer',
  TOTER: 'Toter',
}

export const TYPES_OPTIONS = Object.values(TYPES)

export const TYPE_GROUPS = [
  { label: T.SOLID_WASTE, types: [TYPES.COMPACTOR, TYPES.FRONT_LOAD, TYPES.OPEN_TOP_BOX, TYPES.REAR_LOAD, TYPES.TOTER] },
  { label: T.LIQUID_WASTE, types: [TYPES.HANDWASHING_STATION, TYPES.PORTABLE_TOILET, TYPES.RESTROOM_TRAILER] },
]

export const TYPE_TO_ICON_MAP = {
  [TYPES.COMPACTOR]: Compactor,
  [TYPES.FRONT_LOAD]: FrontLoad,
  [TYPES.HANDWASHING_STATION]: HandwashingStation,
  [TYPES.OPEN_TOP_BOX]: OpenTopBox,
  [TYPES.PORTABLE_TOILET]: PortableToilet,
  [TYPES.REAR_LOAD]: RearLoad,
  [TYPES.RESTROOM_TRAILER]: RestroomTrailer,
  [TYPES.TOTER]: Toter,
}

export const getColumns = (onEdit, onDelete) => [
  {
    flex: 2,
    field: 'name',
    headerName: T.NAME,
  },
  {
    flex: 1,
    field: 'type',
    headerName: T.TYPE,
    type: 'singleSelect',
    valueOptions: TYPES_OPTIONS,
  },
  {
    flex: 2,
    field: 'methods',
    headerName: T.METHODS,
    valueGetter: value => (value ? value.map(method => method.methodType).join(', ') : ''),
  },
  {
    flex: 2,
    field: 'businessLines',
    headerName: T.ASSOCIATED_BUSINESS_LINES,
    valueGetter: value => (value ? value.map(businessLine => businessLine.businessLineLabel).join(', ') : ''),
  },
  {
    display: 'flex',
    flex: 1,
    minWidth: 150,
    field: 'color',
    headerName: T.COLOR,
    valueGetter: value => get(value, 'name', ''),
    renderCell: ({ row }) => <ContainerColor containerColor={get(row, 'color', {})} width={150} />,
  },
  {
    flex: 1,
    field: 'serialized',
    headerName: T.SERIALIZATION,
    valueGetter: value => (value ? T.ENABLED : T.DISABLED),
    type: 'singleSelect',
    valueOptions: [T.ENABLED, T.DISABLED],
  },
  {
    flex: 1,
    field: 'actions',
    type: 'actions',
    align: 'left',
    width: 90,
    getActions: params => RenderGetActionsDataCell({ row: params.row, onEdit, onDelete }),
  },
]
